import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Box from "@mui/material/Box";
import useClasses from "../useClasses";

const styles = (theme) => ({
  icon: {
    alignSelf: "flex-start",
    color: "blue",
  },
  secondaryButton: {
    color: theme.palette.text.secondary,
  },
  alertButton: {
    color: theme.palette.secondary.main,
  },
});

function RemoveDialog(props) {
  const {
    open,
    setOpen,
    removeFunction,
    dialogTitle,
    dialogContentText,
    dialogActionCancel,
    dialogActionConfirm,
  } = props;
  const classes = useClasses(styles);

  const handleClose = () => {
    setOpen((prev) => ({ ...prev, open: false }));
  };

  const handleOk = () => {
    removeFunction();
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="remove-dialog"
      maxWidth="sm"
    >
      <DialogTitle>{dialogTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {dialogContentText}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Box>
          <Button onClick={handleClose} className={classes.secondaryButton}>
            {dialogActionCancel}
          </Button>
        </Box>
        <Box>
          <Button onClick={handleOk} className={classes.alertButton} autoFocus>
            {dialogActionConfirm}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}

export default RemoveDialog;
